export const _en = {
    name: {
        label: "Name"
    },
    refTrainingProductPrefixId: {
        label: "Prefix"
    },
    isExternalMarker: {
        label: "Is out of base"
    },
    refOrganization: {
        label: "Organization"
    },
    type: {
        label: "Type"
    },
    familie: {
        label: "Family"
    },
    siteId: {
        label: "Site"
    },
    adresse: {
        label: "Address"
    },
    PAI: {
        label: "PAI"
    },
    maxNumberOfPeople: {
        label: "Number of trainees"
    },
    planeTypeId: {
        label: "Plane type"
    },
    LMC: {
        label: "LMC",
        tooltip: "Long and Medium Haul"
    },
    rubric: {
        label: "Section"
    },
    season: {
        label: "Season"
    },
    displayVersion: {
        label: "Version"
    },
    startValidityDate: {
        label: "Start validity date"
    },
    endValidityDate: {
        label: "End validity date"
    },
    domain: {
        label: "Domain"
    },
    divisionId: {
        label: "Division"
    },
    stateId: {
        label: "Product state"
    },
    color: {
        label: "Product color"
    },
    crewType: {
        label: "Crew type"
    },
    trainingProductAvailabilityId: {
        label: "Availabilities time"
    },
    lastModificationUserUid: {
        label: "Last modified by"
    },
    lastModifiedDate: {
        label: "Last date modified"
    },
    firstDay: {
        label: "First day"
    },
    defaultBreakTimeBefore: {
        label: "Default break duration before activity"
    },
    defaultBreakTimeAfter: {
        label: "Default break duration after activity"
    },
    automatized: {
        label: "Is automatized ?"
    },
    regulatoryDuration: {
        label: "Regulatory duration"
    },
    beginHour: {
        label: "Begin hour"
    },
    moduleDuration: {
        label: "Module duration"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    refTrainingProductPrefixId: {
        label: "Préfixe / code stage"
    },
    isExternalMarker: {
        label: "Hors base (les stages associés à ces préfixes / codes de stages s'effectueront hors des locaux AF)"
    },
    refOrganization: {
        label: "Compagnie"
    },
    type: {
        label: "Type"
    },
    familie: {
        label: "Famille"
    },
    siteId: {
        label: "Site"
    },
    adresse: {
        label: "Adresse"
    },
    PAI: {
        label: "PAI"
    },
    maxNumberOfPeople: {
        label: "Nombre de stagiaires"
    },
    planeTypeId: {
        label: "Type avion"
    },
    LMC: {
        label: "LMC",
        tooltip: "Long et Moyen Courrier"
    },
    rubric: {
        label: "Rubrique"
    },
    season: {
        label: "Saison"
    },
    displayVersion: {
        label: "Version"
    },
    startValidityDate: {
        label: "Début de validité"
    },
    endValidityDate: {
        label: "Fin de validité"
    },
    domain: {
        label: "Domaine"
    },
    divisionId: {
        label: "Service"
    },
    stateId: {
        label: "État du modèle"
    },
    color: {
        label: "Couleur associée"
    },
    crewType: {
        label: "Type d'équipage"
    },
    trainingProductAvailabilityId: {
        label: "Calendrier de planification"
    },
    lastModificationUserUid: {
        label: "Dernier modificateur"
    },
    lastModifiedDate: {
        label: "Dernière modification"
    },
    firstDay: {
        label: "1er jour"
    },
    duration: {
        label: "Durée du stage"
    },
    defaultBreakTimeBefore: {
        label: "Temps de pause par défaut avant une activité"
    },
    defaultBreakTimeAfter: {
        label: "Temps de pause par défaut après une activité"
    },
    automatized: {
        label: "Numérotation automatique (Si coché le nom du stage sera automatiquement généré)"
    },
    regulatoryDuration: {
        label: "Durée réglementaire"
    },
    beginHour: {
        label: "Heure de début"
    },
    moduleDuration: {
        label: "Durée d'un module"
    }
};